
export const CREATE_FILE_PERMISSION = 'create_file'
export const CREATE_FOLDER_PERMISSION = 'create_folder'
export const CREATE_FORMS_PERMISSION = 'create_forms'
export const CREATE_FORM_LABELS_PERMISSION = 'create_form_labels'
export const CREATE_V2_FORMS_PERMISSION = 'create_v2_forms'
export const DELETE_V2_FORMS_PERMISSION = 'delete_v2_forms'
export const EDIT_FILE_PERMISSION = 'edit_file'
export const READ_V2_FORMS_PERMISSION = 'read_v2_forms'
export const UPDATE_V2_FORMS_PERMISSION = 'update_v2_forms'
